import { Loading } from "@admin/components/atoms/Loading";
import { useCurrentUserGroups } from "@admin/hooks/useCurrentUserGroups";
import { useLicensesControl } from "@admin/hooks/useLicensesControl";
import { Navigate, useLocation } from "react-router";

interface LicenseGuardProps {
  children?: React.ReactNode;
}

export function LicenseGuard({ children }: LicenseGuardProps) {
  const location = useLocation();
  const path = location.pathname;

  const { isSuperAdmin } = useCurrentUserGroups();

  const { shift, food, isPending } = useLicensesControl();

  if (isPending)
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <Loading />
      </div>
    );

  if (!isSuperAdmin && path?.includes("/super-admin"))
    return <Navigate to="/" />;

  if (!shift && path?.includes("/shift-management")) return <Navigate to="/" />;

  if (!food && path?.includes("/food-management")) return <Navigate to="/" />;

  return children;
}
